import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../routeConstants';

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation('common');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const userStr = params.get('user');
        const error = params.get('error');
        
        if (error) {
            navigate(ROUTES.LOGIN, { state: { error } });
            return;
        }

        if (!token || !userStr) {
            navigate(ROUTES.LOGIN, { state: { error: t('auth.errors.authFailed', 'Authentication failed') } });
            return;
        }

        try {
            const user = JSON.parse(decodeURIComponent(userStr));
            
            // Save to localStorage
            localStorage.setItem('token', token);
            
            // Update Redux store
            dispatch({ 
                type: 'auth/SET_TOKEN_AND_USER', 
                payload: { 
                    token, 
                    user 
                } 
            });
            
            // Navigate to dashboard
            navigate(ROUTES.DASHBOARD);
        } catch (e) {
            console.error(t('common.console.authParseError', { error: e }), e);
            navigate(ROUTES.LOGIN, { state: { error: t('auth.errors.authFailed', 'Authentication failed') } });
        }
    }, [location, navigate, dispatch, t]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
                <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-sky-600 border-r-transparent"></div>
                <p className="mt-4 text-gray-600">{t('auth.callback.completing', 'Completing authentication...')}</p>
            </div>
        </div>
    );
} 